import { render, staticRenderFns } from "./LmDocumentViewers.vue?vue&type=template&id=56f0ec83"
import script from "./LmDocumentViewers.vue?vue&type=script&lang=js"
export * from "./LmDocumentViewers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports